// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-image-gallery/styles/css/image-gallery.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Inter;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Poppins;
}

button,
p {
  font-family: Inter;
}

button {
  outline: none;
  border: 0px;
  cursor: pointer;
}

.container {
  max-width: 1180px;
  margin: auto;
}

a {
  text-decoration: none;
}

input {
  border: 0px;
  &:focus {
    border: 0px;
    outline: none;
  }
}

svg,
img {
  display: block;
}

img {
  width: 100%;
  height: 100%;
}

.pagination button {
  color: #303030;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 22.5px;
}

.pagination .Mui-selected {
  border-radius: 3.75px;
  background-color: #ae0000 !important;
  color: #fff;
}

.w-100 {
  width: 100%;
}

label.required::after {
  content: "*";
  color: #d40003;
  margin-left: 2px;
}

.bodyfixed {
  position: fixed;
  inset: 0;
  overflow: hidden;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

.Toastify__toast {
  font-size: 14px;
}

.css-18lrjg1-MuiCircularProgress-root {
  color: #ae0000 !important;
}

.slick-dots li button:before {
  font-size: 12px !important;
}

@media only screen and (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  .slick-dots li button:before {
    font-size: 8px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B,EAAE,YAAY;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import \"~react-image-gallery/styles/css/image-gallery.css\";\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: Inter;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: Poppins;\n}\n\nbutton,\np {\n  font-family: Inter;\n}\n\nbutton {\n  outline: none;\n  border: 0px;\n  cursor: pointer;\n}\n\n.container {\n  max-width: 1180px;\n  margin: auto;\n}\n\na {\n  text-decoration: none;\n}\n\ninput {\n  border: 0px;\n  &:focus {\n    border: 0px;\n    outline: none;\n  }\n}\n\nsvg,\nimg {\n  display: block;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n.pagination button {\n  color: #303030;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22.5px;\n}\n\n.pagination .Mui-selected {\n  border-radius: 3.75px;\n  background-color: #ae0000 !important;\n  color: #fff;\n}\n\n.w-100 {\n  width: 100%;\n}\n\nlabel.required::after {\n  content: \"*\";\n  color: #d40003;\n  margin-left: 2px;\n}\n\n.bodyfixed {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* Firefox */\n}\n\n.Toastify__toast {\n  font-size: 14px;\n}\n\n.css-18lrjg1-MuiCircularProgress-root {\n  color: #ae0000 !important;\n}\n\n.slick-dots li button:before {\n  font-size: 12px !important;\n}\n\n@media only screen and (max-width: 768px) {\n  .container {\n    padding: 0 15px;\n  }\n  .slick-dots li button:before {\n    font-size: 8px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
